import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const StandardFilterField = iotsUtils.fromList(constants.client.search.standardFilterFields);

export const FilterField = iotsUtils.fromList(constants.client.search.filterFields);
